import { css } from 'styled-components';
import { PINK } from '../../../constants/colors';
import { media, rem } from '../../../helpers/mixins';

export default {
  innerwrapper: css`
    transform: translateY(-24px);
    ${media.md`
      margin-top: -162px;
    `};
  `,
  cardItem: css`
    ${media.sm`
      min-height: 350px;
    `};

    ${media.md`
      min-height:350px;
    `};
  `,
  col: css`
    padding: 0;

    ${media.sm`
      padding-left: 8px;
      padding-right: 8px;
    `};
  `,
  title: ({ theme }) => css`
    color: ${PINK};
    font-size: ${rem('26px')};
    line-height: ${rem('35px')};
    margin-bottom: 20px;

    ${media.sm`
       font-size:2.4vw;
       line-height:130%;
    `};

    ${media.md`
       font-size: ${rem('24px')};
       line-height: ${rem('37px')};
    `};
  `
};
